import { Col } from "reactstrap";
import { useContext, useEffect, useState } from "react";
import TableBattery from "./TableBattery";
import TablePvPcs from "./TablePvPcs";
import JanitzaMultimeter from "./JanitzaMultimeter";
import TableWeather from "./TableWeather";
import { SchoolContext } from "../../../context/SchoolContext";
import IwaneElec from "./IwaneElec";
import OtaElec from "./OtaElec";
import FukutaElec from "./FukutaElec";
import HatazawaElec from "./HatazawaElec";
import DainiElec from "./DainiElec";
import JozaiElec from "./JozaiElec";
import KiyomidaiElec from "./KiyomidaiElec";
import TestElec from "./TestElec";
import MitsubishiMultimeter from "./MitsubishiMultimeter";
import TablePvPc50 from "./TablePvPcs50";
import TableUnit from "./TableUnit";
import KoshigayaElec from "./KoshigayaElec";
import SayamaElec from "./SayamaElec";
import AtsugiElec from "./AtsugiElec";
import TablePvPc20 from "./TablePvPcs20";
import TablePvPc111 from "./TablePvPcs111";
import TablePvPcs4 from "./TablePvPcs4";
import { useHistory } from "react-router-dom";
import { idExists } from "../../../utils/NumberUtils";
import { getDeviceId } from "../../../api/api";
import AkirunoElec from "./AkirunoElec";
import HokkaidoElec from "./HokkaidoElec";

const ElectricMgnt = (props) => {
  const { school, schoolList, setSchool } = useContext(SchoolContext);
  const [selected, setSelected] = useState(null);
  const [deviceArr, setDeviceArr] = useState(null);
  const authToken = localStorage.getItem("accessToken");
  const [deviceId, setDeviceId] = useState(null);
  const history = useHistory();
  const pathname = history["location"].pathname;
  const school_id = Number(pathname.split("/").pop());

  useEffect(() => {
    if (deviceId === null) {
      const Value = JSON.parse(localStorage.getItem("schools"));
      const schoolObj = { id: school_id };
      const controller = new AbortController();
      const signal = controller.signal;
      if (
        Value &&
        Value !== null &&
        Value.some((obj) => obj.id === schoolObj.id)
      ) {
        setDeviceId(Value.find((obj) => obj.id === schoolObj.id).device_id);
        setSchool(Value.find((obj) => obj.id === schoolObj.id).id);
      } else {
        if (schoolList.length > 0) {
          if (idExists(schoolList, school_id)) {
            setSchool(school_id);
            const Id = async (signal) => {
              const res = await getDeviceId(
                schoolList[school_id - 1].place_id,
                authToken,
                signal
              );
              if (res && res.sems_device_id) {
                const value = localStorage.getItem("schools");
                const schools = value ? JSON.parse(value) : [];
                const schoolObj = {
                  id: school_id,
                  device_id: res.sems_device_id,
                };
                schools.push(schoolObj);
                localStorage.setItem("schools", JSON.stringify(schools));
                setDeviceId(res.sems_device_id);
              }
            };
            Id(signal);
            return () => {
              controller.abort();
            };
          } else {
            history.push("/home");
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, schoolList, school_id, deviceId]);

  const getComponent = () => {
    if (selected === null) {
      if (school !== null) {
        const currentSchool = school.user_name;
        switch (true) {
          case currentSchool.includes("岩根"):
            return (
              <IwaneElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("太田"):
            return (
              <OtaElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("富来田"):
            return (
              <FukutaElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("畑沢"):
            return (
              <HatazawaElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("木更津第二"):
            return (
              <DainiElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("請西"):
            return (
              <JozaiElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("清見台"):
            return (
              <KiyomidaiElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("株式会社(ZEH)"):
            return (
              <TestElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("北海道銀行"):
            return (
              <HokkaidoElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("KIC越谷"):
            return (
              <KoshigayaElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("KIC狭山"):
            return (
              <SayamaElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("KIC厚木"):
            return (
              <AtsugiElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          case currentSchool.includes("KICあきる野"):
            return (
              <AkirunoElec
                setSelected={setSelected}
                setDeviceArr={setDeviceArr}
                goToInfo={props.goToInfo}
                deviceId={deviceId}
              />
            );
          default:
            return null;
        }
      }
      return null;
    }

    if (
      typeof selected === "object" &&
      selected.device_id.toLowerCase().startsWith("pvpcs") &&
      selected.device_maker_type === "SMA"
    ) {
      return (
        <TablePvPcs
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }
    if (
      typeof selected === "object" &&
      (selected.device_id.toLowerCase().startsWith("pvpcs") ||
        selected.device_id.toLowerCase().startsWith("pv_pcs")) &&
      selected.device_maker_type === "HUAWEI"
    ) {
      return (
        <TablePvPcs4
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }
    if (
      typeof selected === "object" &&
      selected.device_id.toLowerCase().startsWith("20")
    ) {
      return (
        <TablePvPc20
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }
    if (
      typeof selected === "object" &&
      selected.device_id.toLowerCase().startsWith("111")
    ) {
      return (
        <TablePvPc111
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }

    if (
      typeof selected === "object" &&
      (selected.device_id.toLowerCase().startsWith("btpcs") ||
        selected.device_id.toLowerCase().startsWith("bat_pcs"))
    ) {
      //  || selected.includes('pcs2')) {
      return (
        <TableBattery
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }

    if (
      typeof selected === "object" &&
      selected.device_id.toLowerCase().includes("50")
    ) {
      // || selected.includes('pcs1')) {
      return (
        <TablePvPc50
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }

    if (
      typeof selected === "object" &&
      selected.device_id.toLowerCase().startsWith("unit") &&
      selected.hasOwnProperty("data")
    ) {
      //  || selected.includes('sm')) {
      return (
        <TableUnit
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }

    // if (typeof selected === 'object' && selected.device_id.toLowerCase().includes('meter') && selected.device_maker_type.toLowerCase().includes('janitza')) {
    if (
      typeof selected === "object" &&
      selected.device_maker_type.toLowerCase().includes("janitza")
    ) {
      //  || selected.includes('sm')) {
      return (
        <JanitzaMultimeter
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }
    if (
      typeof selected === "object" &&
      selected.device_maker_type.toLowerCase().includes("mitsubishi")
    ) {
      //  || selected.includes('sm')) {
      return (
        <MitsubishiMultimeter
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }

    if (selected === "weather_1") {
      return (
        <TableWeather
          deviceArr={deviceArr}
          selected={selected}
          setSelected={setSelected}
          deviceId={deviceId}
        />
      );
    }
  };

  return (
    <>
      <div className="pt-1" style={{ height: "85vh" }}>
        <Col>{getComponent()}</Col>
      </div>
    </>
  );
};

export default ElectricMgnt;
